import * as React from 'react'
import Box from '@mui/material/Box'
import { TimePicker } from '@user/components/Formik'

import { timeSlots } from '../formConfig'
import { useTidalThemeActive } from '@user/features/TidalThemeToggle'

export function TimeRangePicker() {
  const tidalThemeActive = useTidalThemeActive()

  return (
    <Box display="flex">
      <TimePicker
        fullWidth
        name="startTime"
        label="Time From"
        allowUnlistedTimes
        timeSlots={timeSlots}
        testId="filters-startTime"
        size={tidalThemeActive ? 'medium' : 'small'}
      />

      <Box sx={{ mx: 1 }} />

      <TimePicker
        fullWidth
        name="endTime"
        label="Time To"
        allowUnlistedTimes
        timeSlots={timeSlots}
        testId="filters-endTime"
        size={tidalThemeActive ? 'medium' : 'small'}
      />
    </Box>
  )
}
